<script>
export default {
  props: {
    title: { type: String },
    hideTitle: { type: Boolean, default: false },
    hideClose: { type: Boolean, default: false },
    height: { type: Number, default: 0 },
    autoHeight: { type: Boolean, default: false },
  },
};
</script>